import { useEffect, useRef } from "react";
import { trackEvent } from "@/hooks/useEventTracking";

/**
 * Tracks when a section becomes visible using IntersectionObserver.
 * Each section is tracked once per page load to avoid spam.
 */
export const useSectionTracking = (sectionName: string, threshold = 0.3) => {
  const ref = useRef<HTMLDivElement>(null);
  const tracked = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !tracked.current) {
          tracked.current = true;
          trackEvent("Sekcja widoczna", { section: sectionName });
        }
      },
      { threshold }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [sectionName, threshold]);

  return ref;
};
